/*
 * @Author: youthscc(蒋松)
 * @Date: 2024-04-11 13:52:18
 * @LastEditors: youthscc(蒋松)
 * @LastEditTime: 2024-10-17 14:21:26
 * @Description: 绑定手机号服务数据交互统一入口
 */
let bindMobile = {}

const getHttp = function () {
  return window.$httpUtil.instance
}
// 是否需要同步信息
bindMobile.userCompletionReminder = function () {
  return getHttp().get('/members/userSecurity/userCompletionReminder')
}

export default bindMobile
